import { get } from '@ember/helper';
import ItemBuild from './item-build';

// A single-team lineup row (used by the mobile per-team tables): character avatar,
// two ability skills, gamertag/role, the K/D/A + gold/CS/wards/K% stat cells, and
// the player's item build.
// Args:
//   @player - object with:
//     image, alt, color ('blue'|'red'), level,
//     skills: [{ image, alt }, { image, alt }],
//     gamertag, role,
//     kda: [k, d, a] strings,
//     gold, cs, wards, killPct,
//     build: array of item-image groups (see ItemBuild @groups)
<template>
  <div class='table-row big'>
    <div class='table-row-item'>
      <div class='team-info-wrap medium'>
        <div class='user-avatar-wrap'>
          <img class='user-avatar character v2 {{@player.color}}' src={{@player.image}} alt={{@player.alt}} />
          <p class='user-avatar-text {{@player.color}}'>{{@player.level}}</p>
        </div>
        <div class='skill-loot-list vertical'>
          {{#each @player.skills as |skill|}}
            <img class='skill-loot-item skill-loot-img' src={{skill.image}} alt={{skill.alt}} />
          {{/each}}
        </div>
        <div class='team-info'>
          <p class='team-name'>{{@player.gamertag}}</p>
          <p class='team-country'>{{@player.role}}</p>
        </div>
      </div>
    </div>
    <div class='table-row-item'>
      <p class='table-text bolder'><span class='highlight'>{{get @player.kda 0}}</span>
        /
        <span class='highlight'>{{get @player.kda 1}}</span>
        /
        <span class='highlight'>{{get @player.kda 2}}</span></p>
    </div>
    <div class='table-row-item'>
      <p class='table-text bolder'>{{@player.gold}}</p>
    </div>
    <div class='table-row-item'>
      <p class='table-text bolder'>{{@player.cs}}</p>
    </div>
    <div class='table-row-item'>
      <p class='table-text bolder'>{{@player.wards}}</p>
    </div>
    <div class='table-row-item'>
      <p class='table-text bolder'>{{@player.killPct}}</p>
    </div>
    <div class='table-row-item'>
      <ItemBuild @groups={{@player.build}} />
    </div>
  </div>
</template>
